import { IExtendedEvent } from '@wix/social-groups-serverless/dist/events/types';

export function getScheduleTbdMessage(event: IExtendedEvent) {
  if (event.dateAndTimeSettings?.dateAndTimeTbd) {
    return event.dateAndTimeSettings?.dateAndTimeTbd || 'TBD';
  }
}
